module.exports = __webpack_public_path__ + "img/17_42.c74fc10e.png";